export const GET_RM_APPLICANTS_LOADING = "GET_RM_APPLICANTS_LOADING";
export const GET_RM_APPLICANTS_SUCCESS = "GET_RM_APPLICANTS_SUCCESS";
export const GET_RM_APPLICANTS_FAILURE = "GET_RM_APPLICANTS_FAILURE";

export const SEND_RM_IMPRESSIONS_LOADING = "SEND_RM_IMPRESSIONS_LOADING";
export const SEND_RM_IMPRESSIONS_SUCCESS = "SEND_RM_IMPRESSIONS_SUCCESS";
export const SEND_RM_IMPRESSIONS_FAILURE = "SEND_RM_IMPRESSIONS_FAILURE";

export const GET_IRRELEVANT_LOADING = "GET_IRRELEVANT_LOADING";
export const GET_IRRELEVANT_SUCCESS = "GET_IRRELEVANT_SUCCESS";
export const GET_IRRELEVANT_FAILURE = "GET_IRRELEVANT_FAILURE";

export const GET_QUALITY_FEEDBACK_LOADING = "GET_QUALITY_FEEDBACK_LOADING";
export const GET_QUALITY_FEEDBACK_SUCCESS = "GET_QUALITY_FEEDBACK_SUCCESS";
export const GET_QUALITY_FEEDBACK_FAILURE = "GET_QUALITY_FEEDBACK_FAILURE";

export const SAVE_QUALITY_FEEDBACK_LOADING = "SAVE_QUALITY_FEEDBACK_LOADING";
export const SAVE_QUALITY_FEEDBACK_SUCCESS = "SAVE_QUALITY_FEEDBACK_SUCCESS";
export const SAVE_QUALITY_FEEDBACK_FAILURE = "SAVE_QUALITY_FEEDBACK_FAILURE";

export const GET_REJECTION_OPTIONS_LOADING = "GET_REJECTION_OPTIONS_LOADING";
export const GET_REJECTION_OPTIONS_SUCCESS = "GET_REJECTION_OPTIONS_SUCCESS";
export const GET_REJECTION_OPTIONS_FAILURE = "GET_REJECTION_OPTIONS_FAILURE";

export const SET_AUDIO_PLAYING = "SET_AUDIO_PLAYING";

export const GET_APPLICANTS_COUNT_LOADING = "GET_APPLICANTS_COUNT_LOADING";
export const GET_APPLICANTS_COUNT_FAILURE = "GET_APPLICANTS_COUNT_FAILURE";
export const GET_APPLICANTS_COUNT_SUCCESS = "GET_APPLICANTS_COUNT_SUCCESS";
export const RESET_APPLICANTS = "RESET_APPLICANTS";

export const IS_ACTION_TAKEN = "IS_ACTION_TAKEN";
